import { createContext, useState, useEffect } from "react";
export const CartContext = createContext({
  
});

export function CartProvider({ children }) {
  const [cart, setCart] = useState(
    JSON.parse(localStorage.getItem("cart")) || []
  );

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

   const addToCart = (item) => {
    setCart((prevCart) => [...prevCart, item]);
  }

   const removeFromCart = (itemId) => {
    setCart((prevCart) => prevCart.filter((item) => item.id !== itemId));
  }

  const totalCard = cart.reduce((total, item) => total + item.price * item.quantity, 0);

  const clearCart = () => {
    setCart([]);
  }

  const value = {
    cart,
    setCart,
    addToCart,
    removeFromCart,
    clearCart,
    totalCard,
  };


  return (

    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  );
}
